module.exports = __webpack_public_path__ + "static/media/Thumb_1920x384_FadingLights.61c18d60.jpeg";